exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-link[data-v-169ceb4e] {\n  font-weight: normal;\n}\n.btn-link[data-v-169ceb4e]:not(:hover) {\n  color: #333;\n}\n.btn-link[data-v-169ceb4e]:active {\n  box-shadow: none;\n}\n", ""]);

// exports
